import axios from "axios";
import {toast} from "../class/Notification";
import store from '@/store'
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

const findObject = (arr, key, itemId) =>
    arr.reduce((a, item) => {
        itemId = parseInt(itemId);
        if (a) return a;
        if (item[key] === itemId) return item;
        if (item.children) return findObject(item.children, key, itemId);
    }, null);

const categoryDataShape = (form) => {
    let formData = new FormData();
    formData.append('name', form.name);
    formData.append('slug', form.slug);
    formData.append('language_id', form.language_id);
    formData.append('order', form.order);
    formData.append('status', (form.status === true ? 1 : 0));
    if (form.description != null && form.description != undefined && form.description.trim() != '') formData.append('description', form.description);
    if (form.image.length > 0 || form.image.length == undefined) formData.append('image', form.image);
    if (form.parent_id != null && form.parent_id != "null") formData.append('parent_id', form.parent_id);

    return formData;
}

export const flatCategories = (arr) => {
    return Array.isArray(arr)
        ? arr.reduce((a, item) => {
            a.push(item);
            if (item.children) {
                a = a.concat(flatCategories(item.children));
            }
            return a;
        }, []) : [];
}

export default {
    namespaced: true,
    state: {
        categories: [],
        trash: [],
        category: [],
        filteredCategories: [],
        ...filtersCopy,
    },
    mutations: {
        setCategories(state, list) {
            state.categories = list;
        },
        createCategory(state, category) {
            if (category.parent_id !== null) {
                let categories = findObject(state.categories, "id", category.parent_id);
                categories.children.push(category);
            } else {
                state.categories.push(category);
            }
        },
        deleteCategory(state, category) {
            let index = 0;
            if (category.parent_id != null) {
                let categories = findObject(state.categories, "id", category.parent_id);
                index = categories.children.findIndex(
                    (item) => item.id === category.id
                );
                categories.children.splice(index, 1);
            } else {
                index = state.categories.findIndex((item) => item.id === category.id);
                state.categories.splice(index, 1);
            }
        },
        setTrash(state, list) {
            state.trash = list;
        },
        setCategory(state, category) {
            state.category = category;
        },
        setFilteredCategories(state, categories) {
            state.filteredCategories = categories;
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getCategories({commit, state}) {
            const query = queryBuilder(state.filters)
            axios
                .get(`/category?${query}`)
                .then((res) => {
                    const categories = res.data.data;
                    commit("setCategories", categories);
                    commit("setFilteredCategories", categories);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getDashboardCategories({commit, state}) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/dashboard/category?${query}`)

            req.then((res) => {
                const categories = res.data.data;
                commit("setCategories", categories);
                commit("setFilteredCategories", categories);
            })
                .catch((error) => {
                    console.log(error);
                });
            return req
        },
        createCategory({commit}, form) {
            const reshape = categoryDataShape(form);
            axios
                .post("/category", reshape)
                .then((res) => {
                    toast('عملیات با موفقیت انجام شد', 'دسته بندی با موفقیت ساخته شد.');
                    store.dispatch('Category/getCategories');
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteCategory({commit}, category) {
            axios
                .delete(`/category/${category.id}`)
                .then((res) => {
                    const category = res.data.data;
                    store.dispatch('Category/getCategories')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateCategory({commit}, category) {
            const reshape = categoryDataShape(category);

            reshape.append('_method', 'PUT');

            axios
                .post(`/category/${category.id}`, reshape)
                .then(async (res) => {
                    store.dispatch('Category/getCategories');
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTrashCategories({commit}) {
            axios
                .post("/category/trash")
                .then((res) => {
                    const categories = res.data.data;
                    commit("setTrash", categories);
                    commit("setFilteredCategories", categories);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        restoreCategory({commit}, category) {
            axios
                .put(`/category/${category.id}/restore`)
                .then((res) => {
                    toast('دسته بندی با موفقیت بازیابی شد', 'دسته بندی با موفقیت بازیابی شد')
                    store.dispatch('Category/getTrashCategories')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDelete({commit}, category) {
            axios
                .delete(`/category/${category.id}/force-delete`)
                .then((res) => {
                    toast('دسته بندی با موفقیت حذف شد', 'دسته بندی با موفقیت حذف شد')
                    store.dispatch('Category/getTrashCategories')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setCategory({commit}, category) {
            commit("setCategory", category);
        },
        getCategory({commit}, slug) {
            axios
                .get(`/category/${slug}`)
                .then((res) => {
                    const category = res.data.data;
                    commit("setCategory", category);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeCategoryImage({commit}, category) {
            axios
                .delete(`/category/${category.id}/remove-category-image`)
                .then(async (res) => {
                    toast('عکس دسته بندی با موفقیت حذف شد', 'عکس دسته بندی با موفقیت حذف شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getCategoryWithSlug({commit}, form) {
            return axios.post(`category/find/with/slug`, form)
        },
        getCategoryWithoutState({commit}, slug) {
            return axios.get(`/category/${slug}`)
        },
        getCategoriesWithoutState({commit, state}) {
            const query = queryBuilder(state.filters)
            return axios.get(`/category?${query}`)
        },
        search({commit}, {form}) {
            axios
                .post("/category/search", form)
                .then((res) => {
                    const categories = res.data.data;
                    commit("setCategories", categories);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        categoryHeaders({commit},) {
            return axios.get("/category/headers/category")
        },
    },
    getters: {
        getCategories: (state) => state.categories,
        getTrashCategories: (state) => state.trash,
        getCategory: (state) => state.category,
        getFilteredCategories: (state) => state.filteredCategories,
        getFilters: (state) => state.filters,
    },
};
